import script from "./Gartenkultur-Teams.vue?vue&type=script&setup=true&lang=js"
export * from "./Gartenkultur-Teams.vue?vue&type=script&setup=true&lang=js"

import "./Gartenkultur-Teams.vue?vue&type=style&index=0&id=18412399&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18412399"]])

export default __exports__